/* ============================================================
   DC06 Pack Selector — production initializer (the test's V3).
   Subscribe-first build-your-own-box: thin initializer over the
   shared BYO engine; subscription is the default mode so cards
   show subscription prices and the ReCharge widget renders
   subscription-first. Requires dc06-shared.js loaded first.
   ============================================================ */
(function () {
  function start() {
    if (!window.DC06 || !window.DC06.buildBYO) return false;
    return window.DC06.buildBYO({ rootSelector: '.dc06-v3', rechargeMode: 'subscription', tag: 'v3' });
  }
  var tries = 0;
  var iv = setInterval(function () { tries++; if (start() || tries > 60) clearInterval(iv); }, 200);
  if (document.readyState !== 'loading') start();
  else document.addEventListener('DOMContentLoaded', start);
})();
